import React, { useState } from "react";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import { Button, Flex, Space, Skeleton } from "antd";
import RulesEditModal from "../RulesEditModal/RulesEditModal";
import DeleteUserModal from "../../AgencyComp/UserComp/DeleteUserModal";
import { ReactComponent as EditIcon } from "../../../assets/Icons/Editicon.svg";
import { ReactComponent as TrashIcon } from "../../../assets/Icons/TrashIcon.svg";

import "./RulesTable.scss";
import { deleteRules } from "../../../assets/api/othres";
import { useDispatch, useSelector } from "react-redux";
import { fetchRulesList } from "../../../store/rulesSlice";
import toast from "react-hot-toast";

const RulesTable = ({
  rules_list,
  bankListOption,
  productListOption,
  areaCodeListOption,
  bucketOptions,
  languageOptions,
  loading,
  handlePaginationChange,
}) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState({
    open: false,
    id: null,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [editableRule, setEditableRule] = useState(null);
  const { token } = useSelector((state) => state.auth);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const dispatch = useDispatch();

  const dataSource = rules_list?.results?.map((item, index) => ({
    key: item.id,
    name: item.user?.name || "N/A",
    email: item.user?.email || "N/A",
    user_role: item.user?.role || "N/A",
    bucket: item.bucket || "N/A",
    area: item?.area || "NA",
    product: item?.product,
    portfolio: item?.portfolio,
    language: item?.language,
    region: item?.region,
  }));

  const myExpandedRowRender = (record) => (
    <Flex className="Expanded-main" wrap="wrap" gap={16}>
      <Flex className="detail-container" vertical>
        <h1>Area Codes</h1>
        <p>
          {record.area?.length > 0
            ? record.area.map((area) => area.name).join(", ")
            : "-"}
        </p>
      </Flex>

      <Flex className="detail-container" vertical>
        <h1>Products</h1>
        <p>
          {record.product?.length > 0
            ? record.product.map((prod) => prod.name).join(", ")
            : "-"}
        </p>
      </Flex>

      <Flex className="detail-container" vertical>
        <h1>Banks</h1>
        <p>
          {record.portfolio?.length > 0
            ? record.portfolio.map((bank) => bank.name).join(", ")
            : "-"}
        </p>
      </Flex>

      <Flex className="detail-container" vertical>
        <h1>Region</h1>
        <p>{record.region?.name || "-"}</p>
      </Flex>

      <Flex className="detail-container" vertical>
        <h1>Language</h1>
        <p>{record.language || "-"}</p>
      </Flex>
    </Flex>
  );

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 226,
      render: (name) =>
        loading ? <Skeleton.Input size="small" active /> : name || "-",
    },
    {
      title: "Aging Bucket",
      dataIndex: "bucket",
      key: "bucket",
      width: 210,
      render: (bucket) =>
        loading ? <Skeleton.Input size="small" active /> : bucket || "-",
    },
    {
      title: "User Role",
      dataIndex: "user_role",
      key: "user_role",
      width: 195,
      render: (role) =>
        loading ? <Skeleton.Input size="small" active /> : role || "-",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 330,
      render: (email) =>
        loading ? <Skeleton.Input size="small" active /> : email || "-",
    },
    {
      title: "Actions",
      key: "actions",
      width: 89,
      render: (_, record) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          <Space>
            <Button
              type="text"
              icon={<EditIcon />}
              onClick={() => {
                setIsEditModalOpen(true);
                setEditableRule(record);
              }}
            />
            <Button
              type="text"
              danger
              icon={<TrashIcon />}
              onClick={() =>
                setIsDeleteModalOpen((prev) => ({
                  ...prev,
                  open: true,
                  id: record?.key,
                }))
              }
            />
          </Space>
        ),
    },
  ];

  const handleDeleteRules = async () => {
    try {
      setLoadingDelete(true);
      const res = await deleteRules(isDeleteModalOpen.id, token);
      if (res?.status === 200) {
        setIsDeleteModalOpen({ open: false, id: null });
        dispatch(
          fetchRulesList({ page: currentPage, page_size: pageSize }),
        );
        setCurrentPage(1);
        setPageSize(10);
        toast.success("Rules deleted successfully!");
        setLoadingDelete(false);
      } else {
        toast.error("Failed to delete rules.");
        setLoadingDelete(false);
      }
    } catch (error) {
      setLoadingDelete(false);
    }
  };

  return (
    <div>
      <ReusableTable
        columns={columns}
        dataSource={loading ? Array(5).fill({}) : dataSource}
        rowKey="key"
        bordered
        pageSize={pageSize}
        CurrentPageNo={currentPage}
        totalItems={rules_list?.count || 0}
        setPageSize={setPageSize}
        triggerChange={(page, size) => {
          setCurrentPage(page);
          setPageSize(size);
          handlePaginationChange(page, size);
        }}
        expandedRowRender={!loading ? myExpandedRowRender : undefined}
      />

      <DeleteUserModal
        open={isDeleteModalOpen?.open}
        onClose={() =>
          setIsDeleteModalOpen((prev) => ({
            ...prev,
            open: false,
          }))
        }
        onDelete={handleDeleteRules}
        loading={loadingDelete}
      />
      <RulesEditModal
        open={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        editableRule={editableRule}
        bankListOption={bankListOption}
        productListOption={productListOption}
        areaCodeListOption={areaCodeListOption}
        bucketOptions={bucketOptions}
        languageOptions={languageOptions}
      />
    </div>
  );
};

export default RulesTable;
